export default {
  getLanguageId: (tenant) => {
    return tenant.institution.languageId || tenant.languageId;
  },
  /** @deprecated */
  getAlias: (tenant) => {
    return tenant.alias;
  },
  /** @deprecated */
  getIesAlias: (tenant) => {
    return tenant.iesAlias;
  }
};
